import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { LegalTerms } from '~/components/AgreementStudioPage/AgreementStudioModal/LegalTerms/LegalTerms';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
const getLegalTermErrors = (legalTerms)=>{
    return legalTerms.map((legalTerm)=>{
        var _legalTerm_termsOfService;
        const errors = {};
        if (legalTerm === null) {
            errors.legalTermField = 'Please choose a document';
        }
        if ((legalTerm === null || legalTerm === void 0 ? void 0 : (_legalTerm_termsOfService = legalTerm.termsOfService) === null || _legalTerm_termsOfService === void 0 ? void 0 : _legalTerm_termsOfService.type) === 'explicitApproval') {
            var _legalTerm_termsOfService_explicitApproval_statement, _legalTerm_termsOfService_explicitApproval_statement1;
            if (!((_legalTerm_termsOfService_explicitApproval_statement = legalTerm.termsOfService.explicitApproval.statement) === null || _legalTerm_termsOfService_explicitApproval_statement === void 0 ? void 0 : _legalTerm_termsOfService_explicitApproval_statement.trim())) {
                errors.explicitApproval = 'Please enter a checkbox statement';
            } else if (((_legalTerm_termsOfService_explicitApproval_statement1 = legalTerm.termsOfService.explicitApproval.statement) === null || _legalTerm_termsOfService_explicitApproval_statement1 === void 0 ? void 0 : _legalTerm_termsOfService_explicitApproval_statement1.length) > 120) {
                errors.explicitApproval = 'The statement can be up to 120 characters';
            }
        }
        return errors;
    });
};
const hasLegalTermsErrors = (legalTerms)=>{
    return legalTerms.length === 0 || getLegalTermErrors(legalTerms).some((error)=>error.legalTermField || error.explicitApproval);
};
function TermsOfServiceModalContent(param) {
    let { draft, setDraft, wasSubmitted } = param;
    const legalTermsDocuments = draft.legalTermsDocuments();
    const errors = useMemo(()=>wasSubmitted ? getLegalTermErrors(legalTermsDocuments) : [], [
        wasSubmitted,
        legalTermsDocuments
    ]);
    const onAgreementLegalTermsChange = (updatedLegalTerms)=>{
        setDraft(draft.setLegalTermsDocuments(updatedLegalTerms));
    };
    return /*#__PURE__*/ _jsx(LegalTerms, {
        withTitle: false,
        withExplicitApproval: true,
        agreementLegalTerms: legalTermsDocuments,
        onAgreementLegalTermsChange: onAgreementLegalTermsChange,
        errors: errors,
        editContext: "proposal",
        sourceId: draft.id()
    });
}
export default function TermsOfServiceCell(param) {
    let { isDisabled, disabledTooltip, draft, index, onOpenModal } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const agreementLegalTermsDocuments = draft.legalTermsDocuments();
    const onClick = ()=>onOpenModal({
            submitOnNotDirty: true,
            shouldSubmit: async (editedDraft)=>{
                return !hasLegalTermsErrors(editedDraft.legalTermsDocuments());
            },
            width: '700px',
            maxHeight: '600px',
            renderContent: (param)=>{
                let { draft, setDraft, wasSubmitted } = param;
                return {
                    title: t.termsOfService(),
                    testId: 'edit-terms-modal',
                    content: /*#__PURE__*/ _jsx(TermsOfServiceModalContent, {
                        draft: draft,
                        setDraft: setDraft,
                        wasSubmitted: wasSubmitted
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    const getLegalTermsName = ()=>{
        var _ref;
        var _agreementLegalTermsDocuments_;
        if (agreementLegalTermsDocuments.length > 1) {
            return "".concat(agreementLegalTermsDocuments.length, " documents");
        }
        return (_ref = agreementLegalTermsDocuments === null || agreementLegalTermsDocuments === void 0 ? void 0 : (_agreementLegalTermsDocuments_ = agreementLegalTermsDocuments[0]) === null || _agreementLegalTermsDocuments_ === void 0 ? void 0 : _agreementLegalTermsDocuments_.displayName) !== null && _ref !== void 0 ? _ref : '';
    };
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-terms-of-service-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "terms-of-service-".concat(index),
            children: getLegalTermsName()
        })
    });
}
